import { useGuideConfig } from '@ignitesales/neuro-application/src/neuro-guide/hooks';

export function getRunMode() {
  const { runMode } = useGuideConfig();
  return runMode ? runMode.toLowerCase() : null;
}

// noinspection JSUnusedGlobalSymbols
/**
 * Prod-exactly, purposefully excluding pilot and staging, unlike `isProdLike()` and `isProductionMode()`.
 */
export function isProdExactly() {
  const currentRunMode = getRunMode();
  return currentRunMode === "production";
}

// noinspection JSUnusedGlobalSymbols
/**
 * Prod-like, purposefully excluding staging, unlike `isProductionMode()`.
 */
export function isProdLike() {
  const currentRunMode = getRunMode();
  return currentRunMode === "production" || currentRunMode === "pilot";
}

// noinspection JSUnusedGlobalSymbols
/**
 * Mirror Lift's definition of Production mode, which is any of
 * production, pilot, or staging.
 */
export function isProductionMode() {
  const currentRunMode = getRunMode();
  return currentRunMode === "production" || currentRunMode === "pilot" || currentRunMode === "staging";
}
